export default {
    MENU : "menu",
    PROGRAM: "program",
    MAP : "map",
    INFO : "info"
}
